import { Component, Input } from '@angular/core';

import { NewsItemLayoutType } from 'app/shared/enums/news-item-layout-type';
import { NewsItem } from 'app/shared/models/news-widget/news-item-model';

@Component({
    selector: 'kh-news-widget-item',
    templateUrl: './news-widget-item.component.html',
    styleUrl: './news-widget-item.component.less',
    standalone: false
})
export class NewsWidgetItemComponent {
  @Input() public newsItem!: NewsItem;
  @Input() public hasUnclaimedGift = false;

  public layouts = NewsItemLayoutType;
}
